import { FC, useMemo } from 'react';
import { useRouteMatch, useSSR } from '@funtech-int/rival-react';

import { RouteMeta } from '@/shared/lib/navigation';

import { useRumManager } from '../../hooks/useRumManager';

export const Rum: FC = () => {
    const ssr = useSSR();
    const rum = useRumManager();

    const routeMatch = useRouteMatch();

    const meta = routeMatch.meta as RouteMeta | undefined;
    const pageId = meta?.page;

    useMemo(() => {
        rum.setPage(pageId ?? 'unknown');
    }, [rum, pageId]);

    if (ssr) {
        ssr.addInline(rum.toString());
    }

    return null;
};
